import { supabase } from "@/integrations/supabase/client";

let sessionId: string | null = null;

function getSessionId(): string {
  if (!sessionId) {
    sessionId =
      localStorage.getItem("oplif_session_id") ||
      `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    localStorage.setItem("oplif_session_id", sessionId);
  }
  return sessionId;
}

export function trackEvent(
  eventName: string,
  properties: Record<string, string | number | boolean | null> = {}
) {
  const payload = {
    event_name: eventName,
    properties: properties as any,
    page_path: window.location.pathname,
    session_id: getSessionId(),
  };

  // Fire-and-forget; don't block UI on analytics
  supabase
    .from("analytics_events")
    .insert([payload])
    .then(({ error }) => {
      if (error) console.warn("Analytics insert failed:", error.message);
    });
}
